import {API} from 'aws-amplify';

// @ts-ignore
export const create = async (post) => API.put('robinhoodEngAdminApi', `/likes/${post.id}`, {});

// @ts-ignore
export const del = async (post) => API.del('robinhoodEngAdminApi', `/likes/${post.id}`, {});
